export { ComponentTypes } from './componentTypes';
export { CommandsIds, PermissionsCommandsIds, CommandsIdsGroups, MenuCommandsIds, PageCommandsIds, TopbarCommandsIds, SiteCheckCommandsIds, } from './commandsIds';
export * from './modes';
export * from './permissions';
export * from './contexts';
export * from './indicatorTypes';
export * from './flexValues';
export * from './tourKeys';
export * from './documentIds';
export * from './iterationStrategies';
export * from './positionBox';
export const EditorX_Serverless_AppDefId = '2d8d3e67-5ea4-4e8d-98e4-a1d2f75b60d8';
export const EditorErrorCodes = {
    MissingMasterOfRefComponent: 666,
    MissingMenuContainerInstance: 42,
    MasterNotInMasterPage: 24601,
    CorruptedSectionsGridAreaAndPageTracks: 11,
    NoChildrenToCompRef: 12345,
};
export const PerspectiveAreas = {
    Top: 'WORKSPACE_ARE_TOP',
    Bottom: 'WORKSPACE_ARE_BOTTOM',
    Left: 'WORKSPACE_ARE_LEFT',
    Right: 'WORKSPACE_ARE_RIGHT',
    Stage: 'WORKSPACE_ARE_Stage',
    StageGlobal: 'WORKSPACE_ARE_Stage_Global',
};
export const Perspectives = {
    Edit: 'VIEW_MODE_EDIT',
    Preview: 'VIEW_MODE_PREVIEW',
};
export const ContributionPoints = {
    TopBar: 'TOP_BAR',
    BottomBar: 'BOTTOM_BAR',
    Left: 'LEFT',
    Right: 'RIGHT',
    PreviewFrame: 'PREVIEW_FRAME',
    MigrationPreviewFrame: 'MIGRATION_PREVIEW_FRAME',
    Intro: 'INTRO',
    StaticElementsOverPreview: 'StaticElementsOverPreview',
    IndicationsLayer: 'INDICATIONS_LAYER',
    IndicationsLayerGlobal: 'INDICATIONS_LAYER_GLOBAL',
    OverIndicationsLayer: 'PREVIEW_SIZE_LAYOUT_OVER_INDICATIONS',
    OverIndicationsLayerGlobal: 'PREVIEW_SIZE_LAYOUT_OVER_INDICATIONS_GLOBAL',
    PreviewSizeLayoutUnderPreview: 'PREVIEW_SIZE_LAYOUT_UNDER_PREVIEW',
    LayoutUnderPreview: 'LAYOUT_UNDER_PREVIEW',
    TextEditor: 'TEXT_EDITOR',
    MainScrollableContainer: 'MAIN_SCROLLABLE_CONTAINER',
    Hidden: 'HIDDEN',
    BaseLayer: 'BASE_LAYER',
    CorvidIDE: 'CORVID_IDE',
    MainViewStyle: 'MAIN_VIEW_STYLE',
};
export const ActionNames = {
    AppMarket: 'APP_MARKET',
    AppsPanel: 'APPS_PANEL',
    Undo: 'UNDO',
    Redo: 'REDO',
    Inspector: 'INSPECTOR',
    Layers: 'LAYERS',
    Pages: 'PAGES',
    SharedBlocks: 'SHARED_BLOCKS',
    TreeView: 'TREE_VIEW',
    ContentManager: 'CONTENT_MANAGER',
    AddPanel: 'ADD_PANEL',
    Breakpoints: 'BREAKPOINTS',
    BreakpointsPreview: 'BREAKPOINTS_PREVIEW',
    SizeControlPreview: 'SIZE_CONTROL_PREVIEW',
    InteractionDetector: 'INTERACTION_DETECTOR',
    WidgetThemePreview: 'WIDGET_THEME_PREVIEW',
    TestApiProperties: 'TEST_API_PROPERTIES',
    BlocksTestDynamicProperties: 'BLOCKS_TEST_DYNAMIC_PROPERTIES',
    BlocksLanguagePicker: 'BLOCKS_LANGUAGE_PICKER',
    Zoom: 'ZOOM',
    Save: 'SAVE',
    AutosaveIndication: 'AUTOSAVE_INDICATION',
    Publish: 'Publish',
    PageNavigation: 'PAGE_NAVIGATION',
    Navbar: 'NAVBAR',
    Preview: 'PREVIEW',
    Account: 'ACCOUNT',
    Logo: 'LOGO',
    Theme: 'THEME',
    Presence: 'PRESENCE',
    ShareSite: 'SHARE_SITE',
    Comments: 'COMMENTS',
    LanguagePicker: 'LANGUAGE_PICKER',
    ToggleSiteCheckPanel: 'TOGGLE_SITECHECK_PANEL',
    PingNotifications: 'PING_NOTIFICATIONS',
    MobileWidgets: 'MOBILE_WIDGETS',
};
export const PanelHosts = {
    Left: 'PANEL_LEFT',
    Right: 'PANEL_RIGHT',
    CompPanel: 'PANEL_COMPONENT',
    ToolPanel: 'PANEL_TOOL',
    Bottom: 'PANEL_BOTTOM',
    Docked: 'PANEL_DOCKED',
    ModablePanel: 'PANEL_MODABLE',
};
export const PanelIds = {
    Add: 'panel/add',
    Pages: 'panel/pages',
    Layers: 'panel/layers',
    Inspector: 'panel/inspector',
    SharedBlocks: 'panel/shared-blocks',
    AppMarket: 'panel/app-market',
    AppsPanel: 'panel/apps-panel',
    RepeaterLayout: 'compPanels.panels.Repeater.layoutPanel',
    OrganizerLayout: 'organize-layout-panel',
    Menu: 'panel/menu',
    Theme: 'panel/theme',
    SingleVideoLayout: 'compPanels.panels.VideoPlayer.layoutPanel',
    AnimationPanel: 'compPanels.dynamicPanels.animationPanel',
    ContentManager: 'CONTENT_MANAGER_PANEL_ID',
    AddContentManager: 'panel/add-content-manager',
    TreeView: 'LEFT_TREE_PANE',
    WIX_CODE_IDE: 'WIX_CODE_IDE',
    WIX_CODE_CONSOLE: 'WIX_CODE_CONSOLE',
    Comments: 'panel/comments',
    TimingPanel: 'panel/timing-panel',
    WidgetThemePanel: 'panel/widget-theme',
    StrictColorPickerPanel: 'panel/strict-color-picker-panel',
    SiteCheckPanel: 'panel/site-check-panel',
    StrictColorPickerThemePalettePanel: 'panel/strict-color-picker-theme-palette',
    AppDependenciesManagerPanel: 'panel/app-dependencies-manager',
    AddPanelSectionPanel: 'panel/add-panel-section-panel',
    MobileWidgetsPanel: 'panel/mobile-widgets',
    AddPanelSectionPanelFullList: 'panel/add-panel-section-panel-full-list',
    VideoPlayer: 'modablePanel.panels.workspaceVideoPlayer',
};
export const PanelTags = {
    StructureEditing: 'structure-editing',
};
export const editorBlockingLayerBackgroundId = 'BLOCKING_LAYER_BACKGROUND';
const frameMargin = 24;
export const fakeBrowserAddrersBarHeight = 44;
export const topFrameMargin = `${fakeBrowserAddrersBarHeight + frameMargin}px`;
export const topFrameMarginWithoutFakeBrowser = `${frameMargin}px`;
export const bottomFrameMargin = `${frameMargin}px`;
export const horizontalFrameMargin = '56px';
export const topBarHeight = '97px';
export const topBarHeightInPreview = 52;
export const handleMargin = 24;
export const wixAdsHeight = 50;
export const sidePanelsDefaultWidth = 300;
export const GroupNames = {
    layer: 'layer',
    sections: 'sections',
    grid: 'grid',
    GFPP: 'gfpp',
    editing: 'editing',
    hideAndDelete: 'hideAndDelete',
    breakpoints: 'breakpoints',
    positioning: 'positioning',
    add: 'add',
    anchors: 'anchors',
    masterParts: 'masterParts',
    blocks: 'blocks',
    code: 'code',
    debug: 'debug',
    transform: 'transform',
    copyFormatting: 'copyFormatting',
    scroll: 'scroll',
    help: 'help',
    saveAndPublish: 'saveAndPublish',
    undoRedo: 'undoRedo',
    general: 'general',
    learning: 'learning',
    feedback: 'feedback',
    getFeedback: 'getFeedback',
    site: 'site',
    // After merge of specs.promote-marketing-manager.KillingAscend the line below should be removed
    ascendBusiness: 'ascendBusiness',
    view: 'view',
    updates: 'updates',
    corvid: 'corvid',
    tools: 'tools',
    comment: 'comment',
    savePreset: 'savePreset',
    invite: 'invite',
    accessibility: 'accessibility',
    helpFirst: 'helpFirst',
    helpSecond: 'helpSecond',
    helpThird: 'helpThird',
    helpFourth: 'helpFourth',
    multiselect: 'multiselect',
};
export const CursorOffsets = {
    x: 12,
    y: 15,
};
export const PushNotificationTypes = {
    Default: 'DefaultPushNotificationType',
};
export const unfillShrinkFactor = 0.7;
export const DefaultTransformsToIgnore = ['skew', 'translate', 'scale'];
export const LegacyClassicComponents = [
    'SITE_PAGES',
    'PAGES_CONTAINER',
    'SITE_FOOTER',
    'SITE_HEADER',
    'CONTROLLER_COMP_CUSTOM_ID',
];
//# sourceMappingURL=index.js.map